import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import UserOnglet from "../../user/UserOnglet";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicUseFavoris = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">Gardez une trace de toutes les annonces qui vous plaisent sur Wodzone.</p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Vous avez trouvé un logement ou une expérience que vous aimez ? Il vous suffit de cliquer ou d'appuyer sur 
                le <strong>cœur</strong> pour chaque annonce que vous voulez mettre de côté.
              </p>
              <p className="help-text">
                Vous pouvez enregistrer l'annonce dans une liste de favoris existante ou créer une nouvelle liste de favoris. 
                Si vous enregistrez plusieurs annonces pour la même recherche, elles seront automatiquement ajoutées à la même 
                liste de favoris. Vous pouvez toujours appuyer sur <strong>Modifier</strong> pour enregistrer une annonce dans une autre liste 
                de favoris. Vous pouvez ajouter jusqu'à 100 annonces par liste de favoris.
              </p>
              <p className="help-text">
                À noter : les ajouts à la liste de favoris ne vous réserve pas de places pour vous inscrire.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Supprimer une liste de favoris sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur votre <strong>profil</strong>, puis sur<a target='_blank' className="link" href={'#'}>Favoris.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur la liste de favoris à supprimer.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur les <strong>trois points</strong> ...</p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Cliquez sur <strong>Supprimer</strong>, confirmez votre choix, puis cliquez à nouveau sur <strong>Supprimer.</strong></p>
                      </li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Supprimer une liste de favoris sur un navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyez sur votre <strong>profil</strong>, puis sur<a target='_blank' className="link" href={'#'}>Favoris.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur la liste de favoris à supprimer.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur les <strong>trois points</strong> ...</p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Appuyez sur <strong>Supprimer</strong>, confirmez votre choix, puis appuyez à nouveau sur <strong>Supprimer.</strong></p>
                      </li>
                    </ol>
                  </div>
              }
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Modifier une liste de favoris sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur votre <strong>profil</strong>, puis sur<a target='_blank' className="link" href={'#'}>Favoris.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur la liste de favoris à modifier.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Cliquez sur les <strong>trois points</strong> ...</p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Cliquez sur <strong>Renommer</strong> ou <strong>Supprimer</strong></p>
                      </li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Modifier une liste de favoris sur un navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyez sur votre <strong>profil</strong>, puis sur<a target='_blank' className="link" href={'#'}>Favoris.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur la liste de favoris à modifier.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur les <strong>trois points</strong> ...</p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Appuyez sur <strong>Supprimer</strong>, confirmez votre choix, puis appuyez à nouveau sur <strong>Supprimer.</strong></p>
                      </li>
                    </ol>
                  </div>
              }
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicUseFavoris